<template>
<div class="container">
  <h1>お知らせ</h1>
  <section>
    <div v-for="article in articles">
      <h2>{{ article.title }}</h2>
      <p>{{ article.content }}</p>
    </div>
  </section>
  <h1>最近の画像</h1>
  <b-row>
    <b-col sm="4" v-for="image in imageList.slice(0, 3)" :key="image">
      <b-img thumbnail fluid :src="image" :alt="image" />
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: 'information',
  data() {
    return {
      articles: [
        {
          title   : '望遠鏡メンテナンスのお知らせ',
          content : '2018年1月6日12時から1月8日12時まで、望遠鏡メンテナンスのため、インターネット天文台がご利用いただけません。'
        }
      ],
      imageList: [
        require('../assets/M1.png'),
        require('../assets/M27.png'),
        require('../assets/M33.png'),
        require('../assets/M34.png'),
        require('../assets/M51.png'),
        require('../assets/M52.png'),
        require('../assets/M101.png'),
        require('../assets/M104.png'),
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Information.vue